import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup as MUIRadioGroup } from '@mui/material';
import React from 'react'

export default function RadioGroup(props) {
  const { name, label, value="", onChange, items, row, ...rest } = props;
  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <MUIRadioGroup
        row={row}
        value={value}
        name={name}
        onChange={onChange}
        {...rest}
      >
        {items.map((item) => {
          return <FormControlLabel key={item.id} value={item.id} control={<Radio />} label={item.title} />
        })}
      </MUIRadioGroup>
    </FormControl>
  )
}
